import { createSlice } from '@reduxjs/toolkit';
import { updateLocalStorageToken, logOut } from "../../../../../../containers/resources/utils";
import axios from 'axios';

export const historicalTipTopSplice = createSlice({
  name: 'historicalTipTop',
  initialState: {
    cruises: [],
    years: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  },
  reducers: {
    initialStateHistoricalTipTop(state, action) {
      return {
        cruises: [],
        years: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    requesHistoricalTipTop(state, action) {
      return {
        cruises: [],
        years: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      }
    },
    fetchHistoricalTipTopSuccess(state, action) {
      return {
        cruises: action.payload.cruises,
        years: action.payload.years,
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    fetchHistoricalTipTopError(state, action) {
      return {
        cruises: [],
        years: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.payload.message,
      }
    }
  }
})

export const fetchHistoricalTipTopThunk = (cruiseCode, cruiseYacht, cruiseYear, startYear) => dispatch => {
  dispatch(requesHistoricalTipTop());
  axios.get(`historicalCruises?cruiseCode=${cruiseCode}&cruiseYacht=${cruiseYacht}&cruiseYear=${cruiseYear}&startYear=${startYear}`)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(fetchHistoricalTipTopSuccess(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchHistoricalTipTopThunk(cruiseCode, cruiseYacht, cruiseYear, startYear));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchHistoricalTipTopError(json.data.data));
      }
    })
};

export const {
  initialStateHistoricalTipTop,
  requesHistoricalTipTop,
  fetchHistoricalTipTopSuccess,
  fetchHistoricalTipTopError,
} = historicalTipTopSplice.actions;

export default historicalTipTopSplice.reducer;